module.exports = __webpack_public_path__ + "img/tit2.8e4ff33d.png";